<template>
  <div v-if="visible" class="sender-signature">
    <p class="sender-signature__caption">{{ $t('settings.sender_contact.preview') }}</p>
    <div class="sender-signature__card">
      <img v-if="avatarUrl" class="sender-signature__photo" :src="avatarUrl" alt="" />
      <div>
        <div class="sender-signature__name">{{ senderName }}</div>
        <div v-if="organizationName" class="sender-signature__org">{{ organizationName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue';
  import { useUserStore } from '@/store/userStore';
  import { mailIncludesSenderSignature } from '@/utils/senderSignature';

  export default {
    name: 'SenderSignaturePreview',
    props: {
      body: { type: String, default: '' },
    },
    setup(props) {
      const userStore = useUserStore();

      const senderName = computed(() => {
        const data = userStore.userData || {};
        const meta = userStore.user?.user_metadata || {};
        return [data.first_name || meta.first_name, data.last_name || meta.last_name]
          .filter(Boolean)
          .join(' ')
          .trim();
      });

      const avatarUrl = computed(() => {
        const data = userStore.userData || {};
        const meta = userStore.user?.user_metadata || {};
        return data.avatar_url || meta.avatar_url || '';
      });

      const organizationName = computed(() => userStore.currentOrganization?.name || '');

      const visible = computed(
        () => !!senderName.value && !mailIncludesSenderSignature(props.body),
      );

      return { senderName, avatarUrl, organizationName, visible };
    },
  };
</script>

<style scoped lang="scss">
  .sender-signature {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    &__caption {
      margin: 0;
      @include fontSize('sm');
      color: var(--slate-500);
    }

    &__card {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding-top: 0.75rem;
      border-top: 1px solid var(--slate-200);
    }

    &__photo {
      width: 48px;
      height: 48px;
      border-radius: 24px;
      object-fit: cover;
      flex-shrink: 0;
    }

    &__name {
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.3;
      color: var(--slate-900);
    }

    &__org {
      margin-top: 0.125rem;
      font-size: 0.75rem;
      color: var(--slate-500);
    }
  }
</style>
